import { service } from '../../../../helpers/http' 

export const ActionGetTypeProcesses = ({ dispatch }, payload) => { 
    return service({
        module: 'domainTypeProcess',
        action: 'getTypeProcesses',
        payload: payload
    })
}

export const ActionPostTypeProcesses = ({ dispatch }, payload) => {

    return service({
        module: 'domainTypeProcess',
        action: 'postTypeProcesses',
        payload: payload
    })
    
}

export const ActionPutTypeProcesses = ({ dispatch }, payload) => {

    return service({
        module: 'domainTypeProcess',
        action: 'putTypeProcesses',
        payload: payload
    })
    
}

export const ActionDeleteTypeProcesses = ({ dispatch }, payload) => {

    return service({
        module: 'domainTypeProcess',
        action: 'deleteTypeProcesses',
        payload: payload
    })
    
}
